import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Card, Button, Form, Container, Row, Col } from "react-bootstrap";
import { CognitoUser } from "@aws-amplify/auth"
import { AuthContext } from "../../lib/auth";
import { Modal } from "../common";
import BeginnersImg from '../../../src/images/beginners.png';

enum Progress {
  SignIn,
  ConfirmSignIn,
}

export default () => {
  const [progress, setProgress] = useState<Progress>(Progress.SignIn)
  const [errorMessage, setErrorMessage] = useState<string>("")
  const [modalShow, setModalShow] = useState<boolean>(false)

  const [user, setUser] = useState<any>(null)

  const authContext = useContext(AuthContext)

  const history = useHistory()

  // hooks
  useEffect(() => {
    errorMessage !== "" && setModalShow(true)
  }, [errorMessage])

  useEffect(() => {
    !modalShow && setErrorMessage("")
  }, [modalShow])

  useEffect(() => {
    if (authContext.currentUser) {
      window.location.href = "/auth/mypage"
    }
  }, [authContext.currentUser, history])

  return (
    <section>
      <Modal show={modalShow} message={errorMessage} onHide={() => setModalShow(false)} />
      {progress === Progress.SignIn && <SignIn {...{ setProgress, setUser, setErrorMessage }} />}
      {progress === Progress.ConfirmSignIn && <ConfirmSignIn {...{ user, setProgress, setErrorMessage }} />}
    </section>
  )
}

const SignIn = (props: any) => {
  const randingWebSite = () => {
    window.open("https://wechat-marketing.jp/", '_blank');
  }

  const authContext = useContext(AuthContext)

  const [username, setUsername] = useState<string>("")
  const [attempting, setAttempting] = useState<boolean>(false)

  const handleUsernameChange = (e: any) => setUsername(e.target.value)

  const handleSignInViaOTP = () => {
    setAttempting(true)
    authContext
      .signIn(username)
      .then(data => {
        setAttempting(false)
        props.setProgress(Progress.ConfirmSignIn)
        props.setUser(data)
      })
      .catch(err => {
        setAttempting(false)
        props.setErrorMessage(err.message)
      })
  }

  return (
    <>
      <div onClick={randingWebSite} className="beginners d-block d-sm-none">
        <img src={BeginnersImg} className="img-fluid" alt="Weマーケ!初めての方" />
      </div>
      <Card className="px-3 py-4 mt-5">
        <Card.Header className="bg-white text-dark h5 font-weight-bold pb-4 mb-3">管理画面 ログイン</Card.Header>
        <Card.Body>
          <Form>
            <Form.Group className="text-left">
              <Form.Control
                type="email"
                name="username"
                placeholder="メールアドレス"
                autoComplete="username"
                onChange={handleUsernameChange}
                disabled={attempting}
                className="mb-4 py-4"
              />
            </Form.Group>
            <Form.Group>
              <Button
                className="btn-primary btn-lg mx-auto mb-4 w-100"
                onClick={handleSignInViaOTP}>
                <span>送信</span>
              </Button>
            </Form.Group>
          </Form>
          <Container>
            <Row>
              <Col>
                <Link to="/contact">
                  お問い合わせ
                </Link>
              </Col>
              <Col>
                <Link to="/contact">
                  利用規約
                </Link>
              </Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
      <div onClick={randingWebSite} className="beginners d-none d-sm-block"><img src={BeginnersImg} className="img-fluid" alt="Weマーケ!初めての方" /></div>
    </>
  )
}

const ConfirmSignIn = (props: any) => {
  const authContext = useContext(AuthContext)

  const [confirmCode, setConfirmCode] = useState<string>("")
  const [attempting, setAttempting] = useState<boolean>(false)

  const handleConfirmCodeChange = useCallback((e: any) => setConfirmCode(e.target.value), [])

  const handleConfirm = () => {
    setAttempting(true)
    authContext
      .answerCustomChallenge(props.user, confirmCode)
      .then((user: CognitoUser | any) => {
        setAttempting(false)
        if (!user.signInUserSession) {
          props.setErrorMessage("認証コードが異なります")
        }
      })
      .catch(err => {
        setAttempting(false)
        if (err.message === "Incorrect username or password.") {
          props.setErrorMessage("試行制限を超えました。しばらくしてから試してください")
        } else {
          props.setErrorMessage("無効なコードが提供されました。もう一度コードをリクエストしてください")
        }
      })
  }

  const handleBack = () => {
    setAttempting(true)
    props.setProgress(Progress.SignIn)
    setAttempting(false)
  }

  return (
    <Card className="px-3 py-4 mt-5">
      <Card.Header className="bg-white text-dark h5 font-weight-bold pb-4 mb-3">認証コード入力</Card.Header>
      <Card.Body>
        <Form>
          <Form.Group>
            <Form.Label style={{ fontWeight: 400 }}>
              メールアドレスに送信された認証コードを入力してください
            </Form.Label>
            <Form.Control
              type="number"
              name="confirm-code"
              placeholder="123456"
              disabled={attempting}
              className="mb-5 py-4 btn-lg"
              onChange={handleConfirmCodeChange}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: 20 }}>
            <Button
              className="btn-primary btn-lg"
              onClick={handleConfirm}
              disabled={attempting} block>
              <span>認証</span>
            </Button>
          </Form.Group>
          <Form.Group style={{ marginBottom: 40 }}>
            <Button onClick={handleBack} variant="secondary" block className="w-50 mx-auto">
              <span>戻る</span>
            </Button>
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  )
}